import { render, staticRenderFns } from "./UnknowProductDialog.vue?vue&type=template&id=6c22a7d0&scoped=true"
import script from "./UnknowProductDialog.vue?vue&type=script&lang=js"
export * from "./UnknowProductDialog.vue?vue&type=script&lang=js"
import style0 from "./UnknowProductDialog.vue?vue&type=style&index=0&id=6c22a7d0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c22a7d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c22a7d0')) {
      api.createRecord('6c22a7d0', component.options)
    } else {
      api.reload('6c22a7d0', component.options)
    }
    module.hot.accept("./UnknowProductDialog.vue?vue&type=template&id=6c22a7d0&scoped=true", function () {
      api.rerender('6c22a7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UnknowProductDialog.vue"
export default component.exports